const DEFAULT_MESSAGES = {
  400: 'Некоректний запит або ідентифікатор.',
  404: 'Запис не знайдено або його вже видалено. Оновіть дані чи поверніться до списку.',
  409: 'Виник конфлікт цілісності. Пов’язані дані блокують операцію.',
  422: 'Перевірте значення полів форми.',
  500: 'Помилка сервера. Спробуйте пізніше.',
}

function fieldErrors(fields, fieldMap) {
  if (!fields || typeof fields !== 'object' || Array.isArray(fields)) return {}
  return Object.entries(fields).reduce((result, [field, messages]) => {
    const mapped = fieldMap[field] || field
    const list = Array.isArray(messages) ? messages : [messages]
    const valid = list.filter((message) => typeof message === 'string' && message.trim())
    if (valid.length) result[mapped] = valid
    return result
  }, {})
}

export function normalizeCatalogError(error, options = {}) {
  const status = Number(error?.response?.status) || 0
  const response = error?.response?.data || {}
  const safeBackendMessage = status > 0 && status < 500 && typeof response.message === 'string'
    ? response.message.trim()
    : ''
  const defaultMessage = DEFAULT_MESSAGES[status] || (status >= 500 ? DEFAULT_MESSAGES[500] : 'Не вдалося виконати операцію.')
  if (status >= 500) {
    const logger = options.logger || console
    logger?.error?.('Catalog API request failed', { status, errorCode: response.error_code || null })
  }
  return {
    status,
    errorCode: response.error_code || null,
    details: response.details || {},
    message: safeBackendMessage || options.fallbackMessage || defaultMessage,
    fieldErrors: fieldErrors(response?.details?.fields, options.fieldMap || {}),
    preserveForm: status === 409 || status === 422,
    isStale: status === 404,
    isConflict: status === 409,
  }
}

export function firstFieldError(errors, field) {
  return Array.isArray(errors?.[field]) ? errors[field][0] || '' : ''
}
